export const productDetailAttributeCodes = {
  PRODUCT_DETAILS: "PRODUCT_DETAILS",
  METALS: "METALS",
  PROVIDE_FINGERPRINT_OR_GRAPHIC: "PROVIDE_FINGERPRINT_OR_GRAPHIC",
  MATERIAL: "MATERIAL",
}
